

















/* Created- 24 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";

@Component(
	{
		name: "ParticaCardDialog",
		components: { ParticaCard }
	})
export default class ParticaCardDialog extends Vue {
	@Prop() private title: string; // your data
	@Prop({ default: 500 }) private width: number;
	@Prop() private value: boolean;
	private close() {
		this.$emit("close");
	}
}
